import type { FamilyContact, FamilyContactDetailWithId } from "../../hooks/use-families";

export const SELF_INVARIANT_MESSAGES = {
  contactMethod: "A student-inquirer contact must have at least one contact method.",
  grade: "A student-inquirer contact must have a grade.",
  both: "A student-inquirer contact must have a grade and at least one contact method.",
  sameContact: "Self relationship requires the same contact for student and inquirer."
} as const;

export const isSameContact = (
  inquirer?: FamilyContact | null,
  student?: FamilyContact | null
) => {
  if (!inquirer?.id || !student?.id) {
    return false;
  }

  return `${inquirer.id}` === `${student.id}`;
};

export const getSelfEligibilityMessage = (
  contactDetail?: Pick<
    FamilyContactDetailWithId,
    "gradeId" | "grade" | "email" | "personalPhone" | "homePhone" | "businessPhone"
  >
) => {
  if (!contactDetail) {
    return "";
  }

  const hasGrade = Boolean(contactDetail.gradeId || contactDetail.grade?.value);
  const hasContactMethod = Boolean(
    contactDetail.email?.trim() ||
      contactDetail.personalPhone?.trim() ||
      contactDetail.homePhone?.trim() ||
      contactDetail.businessPhone?.trim()
  );

  if (!hasGrade && !hasContactMethod) {
    return SELF_INVARIANT_MESSAGES.both;
  }

  if (!hasGrade) {
    return SELF_INVARIANT_MESSAGES.grade;
  }

  if (!hasContactMethod) {
    return SELF_INVARIANT_MESSAGES.contactMethod;
  }

  return "";
};
